module.exports = __webpack_public_path__ + "static/media/partner-logo7.5dbc765c.png";